/* istanbul ignore file */
import { array as codecArray, optional as codecOptional } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { JsonCreateAutoTest } from './JsonCreateAutoTest';
const CreateAutoTestDataParser = /* #__PURE__ */ parsers.object([
    ['json', JsonCreateAutoTest],
    ['fixture', /* #__PURE__ */ codecOptional(/* #__PURE__ */ codecArray(parsers.file))],
]);
export class CreateAutoTestData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CreateAutoTestDataParser.decode(input).map(res => new CreateAutoTestData(res));
    }
    static unsafeDecode(input) {
        return CreateAutoTestData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CreateAutoTestDataParser.encode(data);
    }
    static schema() {
        return CreateAutoTestDataParser.schema();
    }
}
